// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"jdViewModal_modalContent__bR5EQ"};